<template>
  <section class="body">
    <div class="modal-top-section modal-top-section--align-center">
      <h3 class="modal-top-section__title">Agrega canales (opcional)</h3>
      <p class="modal-top-section__subtitle">
        Esta cola recepciona los tickets y llamadas que ingresen por los canales que vayas a
        configurar. Estos tickets podrán ser transferidos a cualquier cola asociada a la misma
        campaña. También puedes crear colas sin canales asociados para ser utilizadas solo en
        transferencias.
      </p>
    </div>

    <div class="title-channel">
      <div class="select-channels">
        <selector-channels
          :value="channels_customer"
          @update:value="channels_customer = $event"
          :blocked-identifiers="blockedIdentifiers"
          isQueue
          skipFilterQueue
        />
      </div>
    </div>
  </section>
</template>

<script>
import SelectorChannels from "@/app/shared/components/selectors/SelectorChannels.vue";
import { useAgentAIIdentifiers } from "@/app/shared/composables/useAgentAIIdentifiers";
import { defineComponent } from "vue";

export default defineComponent({
  components: { SelectorChannels },
  setup() {
    // Los identificadores de un Agente IA no se pueden usar en colas
    const { blockedIdentifiers } = useAgentAIIdentifiers();
    return { blockedIdentifiers };
  },
  computed: {
    channels_customer: {
      get() {
        this.$emit("disable", false);
        return this.$store.getters["getQueueState"].channels_customer;
      },
      set(channels_customer) {
        this.$emit("onShowConfirmationModal");
        this.$store.dispatch("setQueueProperties", { channels_customer });
      },
    },
  },
  watch: {},
  methods: {
    handleOk(current) {
      return current + 1;
    },
    handleReset() {
      this.channels_customer = [];
    },
  },
});
</script>

<style lang="sass" scoped>
.body
  padding: 0 5px

.title-channel
  padding: 10px
  margin: 15px 15px
  span
    margin-top: 15px
    font-size: 14px
    font-weight: 600
.italic-style
  font-style: italic
  text-align: justify
</style>
